import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import dialogPlugin, { dialog } from 'BASE/plugins/dialogPlugin';
import autoCompletePlugin from 'BASE/plugins/autoCompletePlugin';
import router from 'LS/router';
import store from 'LS/store/store';
import ajaxSetting from 'BASE/components/ajaxSetting.component';
import App from 'LS/views/App.vue';
import dialogComponent from 'LS/views/Dialog.vue';
import VueClipboard from 'vue-clipboard2';
import Loading from 'vue-loading-overlay';
import loginPlugin from 'BASE/plugins/loginPlugin';
import logoComponent from 'LS/views/Logo.vue';
import LoadingComponent from 'LS/views/Loading.vue';
import 'vue2-datepicker/locale/zh-cn';  //統一變更時間選擇器語系
import VueCircleSlider from 'vue-circle-slider'
import 'BASE/filters/numberFilter'; // 增加number的Filter
import numberPlugin from 'BASE/plugins/numberPlugin';
import vueIframe from 'BASE/plugins/vue-iframes';
import datadogRumPlugin from 'BASE/plugins/datadogRumPlugin';
import UrlManager from 'BASE/common/UrlManager';

Vue.use(UrlManager);
sync(store, router);
Vue.use(autoCompletePlugin);
Vue.use(dialogPlugin, { dialogComponent });
Vue.use(loginPlugin, { router, dialog });
Vue.use(numberPlugin);

VueClipboard.config.autoSetContainer = true; //讓vue-clipboard2將container 設置為當前元素，避免在Bootstrap 模式不工作
Vue.use(VueClipboard);

Vue.use(require('vue-moment'));

Vue.use(VueCircleSlider);
Vue.use(vueIframe);
Vue.component('custom-loader', LoadingComponent);
Vue.use(Loading, {
    loader: 'spinner',
    width: 64,
    height: 64,
    zIndex: 9999,
    backgroundColor:'rgba(0,0,0,0.6)',
},{
    default: (new Vue()).$createElement('custom-loader'),           
});

Vue.use(datadogRumPlugin, { isMobile: false });

Vue.component('logo', logoComponent);

new Vue({
    router,
    store,
    render: h => h(App),
    mixins: [ajaxSetting]
}).$mount('#app');
